import { Button, Result, Tooltip } from 'antd'
import React from 'react'

/** Breadcrumb item for the current article; long titles are truncated with a tooltip */
export const buildArticleBreadcrumb = (title: string) => ({
  title: (
    <Tooltip title={title}>
      <span className="faq-breadcrumb-title">{title}</span>
    </Tooltip>
  ),
})

/** 404, or 400 for a malformed id; a missing payload is treated the same way */
const isArticleNotFound = (error: unknown) => {
  if (!error) return true
  const status = (error as { status?: number }).status
  return status === 404 || status === 400
}

interface FaqArticleLoadErrorProps {
  error: unknown
  onBack: () => void
  onRetry: () => void
}

export const FaqArticleLoadError: React.FC<FaqArticleLoadErrorProps> = ({
  error,
  onBack,
  onRetry,
}) => {
  const notFound = isArticleNotFound(error)
  return (
    <Result
      status={notFound ? '404' : 'error'}
      title={notFound ? 'Article not found' : 'Failed to load article'}
      subTitle={notFound ? 'This article may have been deleted.' : undefined}
      extra={[
        notFound ? null : (
          <Button key="retry" onClick={onRetry}>
            Retry
          </Button>
        ),
        <Button key="back" type="primary" onClick={onBack}>
          Back to FAQ Management
        </Button>,
      ]}
    />
  )
}
